<app-sysinfo-view [versionData]="versionData$ | async" [codes]="codes$ | async"
    [launchResources]="launchResources$ | async" (downloadCodes)="downloadCodes()" (generateCodes)="generateCodes()">
</app-sysinfo-view>